/** Remove acentos/diacríticos e caixa: "Lê Souza" -> "le souza". */
export function normalizeText(value: string): string {
  return (value ?? "")
    .normalize("NFD")                 // separa a letra base do diacrítico
    .replace(/[\u0300-\u036f]/g, "")  // descarta os diacríticos combinantes
    .toLowerCase()
    .trim();
}

/**
 * Casa `search` contra `label` ignorando acentos, caixa e ordem das palavras.
 * Todas as palavras digitadas precisam aparecer no texto.
 */
export function matchesSearch(label: string, search: string): boolean {
  const haystack = normalizeText(label);
  const terms = normalizeText(search).split(/\s+/).filter(Boolean);
  return terms.every((term) => haystack.includes(term));
}
